module.exports = __webpack_public_path__ + "img/gatsby.06aea797.png";